export const CHANGE_STATUS_MODAL_OLX = "CHANGE_STATUS_MODAL_OLX"
export const LIST_BRAND_OLX = "LIST_BRAND_OLX"
export const LIST_MODEL_OLX = "LIST_MODEL_OLX"
export const LIST_YEAR_OLX = "LIST_YEAR_OLX"
export const LIST_VERSION_OLX = "LIST_VERSION_OLX"	
export const SEND_FORM_OLX = "SEND_FORM_OLX"